// modSelectors.js

export const selectRecentMealData = (state) => state.meals.allMeals; // Selector to get meals data
export const selectMealsPagination = (state) => state.meals.pagination; // Selector to get meals data
export const selectUserFavoriteMealsPagination = (state) =>
  state.meals.favoritePagination; // Selector to get meals data
export const selectUserRecentMealData = (state) => state.meals.userMeals; // Selector to get meals data
export const selectViewingUserInfoData = (state) => state.meals.viewingUserData; // Selector to get meals data
export const selectUserFavoriteRecentMealData = (state) =>
  state.meals.userFavoriteMeals; // Selector to get meals data
export const selectLoading = (state) => state.meals.loading; // Selector to get loading state
export const selectFavoriteLoading = (state) => state.meals.favLoading; // Selector to get loading state
export const selectError = (state) => state.meals.error; // Selector for error state
